import { Fragment } from 'react';
import ImageWithPlaceholder from '@/modules/store/components/ImageWithPlaceholder';
import { getImageSizeUrl, Image } from '@/modules/store/models/Image';
import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface ImageDialogProps {
  image?: Image | null;
  onClose?: () => void;
  getImageUrl?: (image: Image) => string;
}

const largeImageUrlGetter = (image: Image) => getImageSizeUrl(image, 'LARGE');

const ImageDialog = ({
  image,
  onClose = () => {},
  getImageUrl = largeImageUrlGetter,
}: ImageDialogProps) => {
  return (
    <Transition show={!!image} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={() => onClose()}>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-60" />
        </TransitionChild>

        <div className="fixed inset-0 flex items-center justify-center p-4">
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-200"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-150"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <DialogPanel className="relative bg-white rounded-2xl shadow-xl max-w-4xl w-full overflow-hidden">
              <button
                type="button"
                onClick={() => onClose()}
                className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 z-10"
              >
                <XMarkIcon className="w-6 h-6" />
              </button>

              {image && <ImageWithPlaceholder src={getImageUrl(image)} alt="Large product" />}
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ImageDialog;
